import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { JVDate } from "../../shared/JVDate";
import { JVInput } from "../../shared/JVInput";
import { FileUpload, FileUploadHandlerParam } from "primereact/fileupload";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { ITimesheet } from "../../models/Timesheet";
import { Fetch, baseUrl } from "../../shared/Fetch";
import { IPurchaseOrder } from "../../models/PurchaseOrder";
import { JVRadioBtn } from "../../shared/JVRadioBtn";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { set } from "date-fns";

interface IProps {
    singleData: ITimesheet,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    po?: IPurchaseOrder,
    recent: ITimesheet,
}

const schema = yup.object({
    fromDate: yup.date().required("From Date is required").typeError("From Date is required"),
    toDate: yup.date().required("To Date is required").typeError("To Date is required"),
    workHours: yup.string().max(90).required("Work Hours is required"),
    // overlapWorkHours: yup.string().required("Overlap Work Hours is required"),
    overlapWorkHours: yup.string().nullable(),
    timeSheet_Path: yup.string().nullable(),
    comments: yup.string().nullable(),
    isNotWorking: yup.boolean().nullable(),
});

export const AddConsultantTimeSheet = (props: IProps) => {
    const [loading, setLoading] = useState(false);
    const [fileUploaded, setFileUploaded] = useState(false);
    const [disableAllField, setDisableAllField] = useState(false);
    const [showOverlap, setShowOverlap] = useState<boolean>(false);
    const [workHoursHeader, setWorkHoursHeader] = useState<string>("Work Hours");
    const [overlapHoursHeader, setOverlapHoursHeader] = useState<string>("Overlaping Hours");
    const [timesheetFile, setTimesheetFile] = useState<File | null | any>(null);

    const { control, handleSubmit, formState: { errors }, reset, setValue, watch } = useForm<ITimesheet>({
        resolver: yupResolver(schema),
        defaultValues: {},
        shouldFocusError: false
    });

    const fileUploade = (event: FileUploadHandlerParam) => {
        if (event.files[0].size >= 1024 * 1024 * 5) {
            props.toast.current.show({ severity: 'error', content: "Document should be less than 5 MB." });
            event.options.clear();
        } else {
            props.toast.current.show({ severity: 'success', content: "A Document Selected." });
            setTimesheetFile(event.files[0]);
            setFileUploaded(true);
            event.options.clear();
        }
    }

    const uploadeFile = async (file: File) => {
        setLoading(true);
        let formData = new FormData();
        formData.append("file", file);

        const params = {
            method: "POST",
            headers: {
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            },
            body: formData
        };
        const response = await fetch(`${baseUrl}Ticket/file`, params);
        if (response.ok) {
            const data = await response.text();
            setValue("timeSheet_Path", data);
            props.toast.current.show({ severity: 'success', content: `Document Uploaded Successfully as -"${data}"` });
            setFileUploaded(prev => prev = true);
        }
        setLoading(false);
    }

    const onSubmit = (data: ITimesheet) => {
        // data.consultant_ID = props.singleData.consultant_ID;
        // data.pO_ID = props.singleData.pO_ID;
        const toDate = new Date(data.toDate || "");
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (toDate > today) {
            props.toast.current.show({ severity: 'error', content: `Week not ended yet` });
        } else if (fileUploaded === false && disableAllField === false) {
            props.toast.current.show({ severity: 'error', content: `Uploaded Document First` });
        } else {
            if ((new Date(data.fromDate || "").getMonth() + 1 !== new Date(data.toDate || "").getMonth() + 1) && (data.overlapWorkHours === null || data.overlapWorkHours === undefined)) {
                props.toast.current.show({ severity: 'error', content: `Overlap Work Hours is set to 0` });
                data.overlapWorkHours = 0;
            }

            if (new Date(data?.fromDate || "").getMonth() + 1 === new Date(data?.toDate || "").getMonth() + 1) {
                if ((Number(data?.workHours || "0") + Number(data?.overlapWorkHours || "0")) >= 91) {
                    props.toast.current.show({ severity: 'error', content: `Working Hours can not be greater than 90` });
                } else {
                    if (props.po?.pO_Status === "Joined") {
                        saveToDB(data);
                    } else if (props.po?.pO_Status === "Ended" && props.po?.project_End_Date !== undefined && props.po?.project_End_Date !== null && new Date(data?.toDate || "") <= new Date(props.po?.project_End_Date || "")) {
                        saveToDB(data);
                    } else props.toast.current.show({ severity: 'error', content: `Timesheet can not be added as PO Status is not Joined` });
                }
            } else if (new Date(data?.fromDate || "").getMonth() + 1 !== new Date(data?.toDate || "").getMonth() + 1 && (data.overlapWorkHours !== undefined && data.overlapWorkHours !== null)) {
                if ((Number(data?.workHours || "0") + Number(data?.overlapWorkHours || "0")) >= 91) {
                    props.toast.current.show({ severity: 'error', content: `Working Hours can not be greater than 90` });
                } else {
                    if (props.po?.pO_Status === "Joined") {
                        saveToDB(data);
                    } else if (props.po?.pO_Status === "Ended" && props.po?.project_End_Date !== undefined && props.po?.project_End_Date !== null && new Date(data?.toDate || "") <= new Date(props.po?.project_End_Date || "")) {
                        saveToDB(data);
                    } else props.toast.current.show({ severity: 'error', content: `Timesheet can not be added as PO Status is not Joined` });
                }
            } else props.toast.current.show({ severity: 'error', content: `Please Enter Overlap Hours` });
        }
    }

    const saveToDB = async (data: ITimesheet) => {
        let body: any = data;

        if (typeof Number(data.workHours) !== 'number' && disableAllField === false) {
            props.toast.current.show({ severity: 'error', detail: "Working Hours Must Be In Numbers", life: 3000 });
        } else if (Number(data.workHours) < 0) {
            props.toast.current.show({ severity: 'error', detail: "Working Hours Must Be Greter or Equal to 0", life: 3000 });
        } else {
            body.workHours = Number(data.workHours);

            setLoading(true);
            const method = props.singleData.timesheet_ID ? "PUT" : "POST";
            const message = props.singleData.timesheet_ID ? "Updated Successfully" : "Added Successfully";

            const formData = new FormData();
            formData.append('file', timesheetFile);
            formData.append('newTimesheet', JSON.stringify(body));
            const params = {
                method: method,
                headers: {
                    'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
                },
                body: formData
            };
            const response = await fetch(`${baseUrl}Timesheet`, params);
            // const response = await Fetch("Timesheet", method, body, null, props.toast);
            if (response.ok) {
                setDisableAllField(prev => prev = false);
                onHide();
                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                props.setReload(!props.reload);
            }
            setLoading(false);
        }
    }

    const onHide = () => {
        setTimesheetFile(null);
        setFileUploaded(false);
        setShowOverlap(prev => prev = false);
        setDisableAllField(prev => prev = false);
        setWorkHoursHeader("Work Hours");
        setOverlapHoursHeader("Overlaping Hours");
        reset();
        props.hideDialog();
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "fromDate") {
                if (value.fromDate != null) {
                    const dayOfWeek = value.fromDate.getDay();
                    if (dayOfWeek === 0) {
                        setValue('toDate', value.fromDate);

                        setWorkHoursHeader("Work Hours");
                        setOverlapHoursHeader("Overlaping Hours");
                        setValue('overlapWorkHours', 0);
                        setShowOverlap(false);
                    } else {
                        setValue('toDate', new Date(new Date(value.fromDate).setDate(new Date(value.fromDate).getDate() + ((6 - dayOfWeek) + 1))));

                        const toDateIs: Date = new Date(new Date(value.fromDate).setDate(new Date(value.fromDate).getDate() + ((6 - dayOfWeek) + 1)));

                        if (new Date(value.fromDate || "").getMonth() + 1 !== new Date(toDateIs || "").getMonth() + 1) {
                            setShowOverlap(true);
                            const lastDateOfFrom = new Date(new Date(value.fromDate || "").getFullYear(), new Date(value.fromDate || "").getMonth() + 1, 0);
                            const firstDateOfTo = new Date(new Date(toDateIs || "").getFullYear(), new Date(toDateIs || "").getMonth(), 1);
                            setWorkHoursHeader(`Work Hours : (${new Date(value.fromDate || "").getDate()}-${new Date(value.fromDate || "").getMonth() + 1}-${new Date(value.fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
                            setOverlapHoursHeader(`Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(toDateIs || "").getDate()}-${new Date(toDateIs || "").getMonth() + 1}-${new Date(toDateIs || "").getFullYear()})`);
                        }

                        if ((props.po?.sub_Vendor_Billing_Cycle === "Bi-Weekly" || props.po?.prime_Vendor_Billing_Cycle === "Bi-Weekly") && new Date(value.fromDate || "").getDate() < 16 && new Date(toDateIs || "").getDate() >= 16) {
                            setShowOverlap(true);
                            const lastDateOfFrom = new Date(new Date(value.fromDate || "").getFullYear(), new Date(value.fromDate || "").getMonth(), 15);
                            const firstDateOfTo = new Date(new Date(toDateIs || "").getFullYear(), new Date(toDateIs || "").getMonth(), 16);
                            setWorkHoursHeader(`Work Hours : (${new Date(value.fromDate || "").getDate()}-${new Date(value.fromDate || "").getMonth() + 1}-${new Date(value.fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
                            setOverlapHoursHeader(`Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(toDateIs || "").getDate()}-${new Date(toDateIs || "").getMonth() + 1}-${new Date(toDateIs || "").getFullYear()})`);
                        }

                        if (new Date(value.fromDate || "").getMonth() + 1 === new Date(toDateIs || "").getMonth() + 1) {
                            setWorkHoursHeader("Work Hours");
                            setOverlapHoursHeader("Overlaping Hours");
                            setValue('overlapWorkHours', 0);
                            setShowOverlap(false);
                        }
                    }
                }
            }
            if (name === "isNotWorking") {
                if (value.isNotWorking != null) {
                    if (value.isNotWorking === true) {
                        setDisableAllField(prev => prev = true);
                        setValue("workHours", 0);
                        setValue("overlapWorkHours", 0);
                        setValue("timeSheet_Path", "null");
                        setFileUploaded(prev => prev = false);
                    } else {
                        setDisableAllField(prev => prev = false);
                    }
                }
            }
        });
        return () => subscription.unsubscribe();
    }, [watch, workHoursHeader, overlapHoursHeader, showOverlap]);

    useEffect(() => {
        if (props.open) {
            if (props.singleData?.timesheet_ID && props.singleData?.isNotWorking === true) {
                setDisableAllField(true);
            }
            const weekStartDay = props?.po?.timesheet_Week_Start_Day || 0;
            if (props.recent === undefined || props.recent?.toDate === null) {
                props.singleData.fromDate = new Date(props?.po?.project_Start_Date || "");
                const currentDate = new Date(props?.po?.project_Start_Date || "");
                let numberOfDaysToAdd = (weekStartDay - Number(new Date(props?.po?.project_Start_Date || "")?.getDay()) + 7) % 7;
                const toDate = new Date(currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd));
                props.singleData.toDate = toDate;
            } else if (props.recent?.toDate && props.recent?.toDate !== null) {
                const fromDate = new Date(new Date(props.recent?.toDate || "").setDate(new Date(props.recent?.toDate || "").getDate() + 1));
                props.singleData.fromDate = fromDate;
                let numberOfDaysToAdd = (weekStartDay - Number(fromDate?.getDay()) + 7) % 7;
                const newFromDate = new Date(new Date(props.recent?.toDate || "").setDate(new Date(props.recent?.toDate || "").getDate() + 1));
                const toDate = new Date(newFromDate.setDate(newFromDate.getDate() + numberOfDaysToAdd));
                // const toDate = new Date(new Date(props.recent?.toDate || "").setDate(new Date(props.recent?.toDate || "").getDate() + numberOfDaysToAdd));
                props.singleData.toDate = toDate;
            }

            if (new Date(props.singleData?.fromDate || "").getMonth() + 1 !== new Date(props.singleData?.toDate || "").getMonth() + 1) {
                setShowOverlap(prev => prev = true);

                const lastDateOfFrom = new Date(new Date(props.singleData?.fromDate || "").getFullYear(), new Date(props.singleData?.fromDate || "").getMonth() + 1, 0);
                const firstDateOfTo = new Date(new Date(props.singleData?.toDate || "").getFullYear(), new Date(props.singleData?.toDate || "").getMonth(), 1);
                setWorkHoursHeader(`Work Hours : (${new Date(props.singleData?.fromDate || "").getDate()}-${new Date(props.singleData?.fromDate || "").getMonth() + 1}-${new Date(props.singleData?.fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
                setOverlapHoursHeader(`Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(props.singleData?.toDate || "").getDate()}-${new Date(props.singleData?.toDate || "").getMonth() + 1}-${new Date(props.singleData?.toDate || "").getFullYear()})`);
            }

            if ((props?.po?.sub_Vendor_Billing_Cycle === "Semi-Monthly" || props?.po?.prime_Vendor_Billing_Cycle === "Semi-Monthly") && new Date(props.singleData?.fromDate || "").getDate() < 16 && new Date(props.singleData?.toDate || "").getDate() >= 16) {
                setShowOverlap(prev => prev = true);

                const lastDateOfFrom = new Date(new Date(props.singleData?.fromDate || "").getFullYear(), new Date(props.singleData?.fromDate || "").getMonth(), 15);
                const firstDateOfTo = new Date(new Date(props.singleData?.toDate || "").getFullYear(), new Date(props.singleData?.toDate || "").getMonth(), 16);
                setWorkHoursHeader(`Work Hours : (${new Date(props.singleData?.fromDate || "").getDate()}-${new Date(props.singleData?.fromDate || "").getMonth() + 1}-${new Date(props.singleData?.fromDate || "").getFullYear()}) to (${lastDateOfFrom.getDate()}-${lastDateOfFrom.getMonth() + 1}-${lastDateOfFrom.getFullYear()})`);
                setOverlapHoursHeader(`Overlaping Hours : (${firstDateOfTo.getDate()}-${firstDateOfTo.getMonth() + 1}-${firstDateOfTo.getFullYear()}) to (${new Date(props.singleData?.toDate || "").getDate()}-${new Date(props.singleData?.toDate || "").getMonth() + 1}-${new Date(props.singleData?.toDate || "").getFullYear()})`);
            }

            reset(props.singleData);
        }
    }, [props.open]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Update Consultant TimeSheet" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVDate required column={3} label="From Date" maxDate={new Date()} control={control} name="fromDate" error={errors.fromDate?.message} />
                <JVDate required column={3} label="To Date" maxDate={new Date()} disabled control={control} name="toDate" error={errors.toDate?.message} />
                <JVInput required column={3} label={workHoursHeader} disabled={disableAllField} control={control} name="workHours" error={errors.workHours?.message} />
                {showOverlap && <JVInput required column={3} label={overlapHoursHeader} disabled={disableAllField && showOverlap} control={control} name="overlapWorkHours" error={errors.overlapWorkHours?.message} />}
                <div className="field col-12 md:col-2">
                    <label htmlFor="file">TimeSheet<span style={{ color: 'red' }}>*</span></label>
                    <FileUpload disabled={disableAllField} chooseLabel="Choose File" mode="basic" name="file" accept="*" maxFileSize={10000000} customUpload auto uploadHandler={fileUploade} />
                    {errors.timeSheet_Path?.message && <small className="p-error" >{errors.timeSheet_Path?.message}</small>}
                </div>
                <div className="field col-12 md:col-3 pt-5">
                    <JVCheckbox column={1} label="Not Worked" control={control} name="isNotWorking" />
                </div>
                <JVInput column={2} label="Comment" control={control} name="comments" error={errors.comments?.message} />

                <div className="col-12 md:col-12" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '10px' }}>
                    <Button className="field col-12 md:col-6  h-2rem" label="SAVE" type="submit" loading={loading}></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined  h-2rem" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}